import { Box, Checkbox, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import { TextGray } from "components/Atomos/Texts/TextGray";
import { useCamadas } from "../../contexts/CamadasProvider";

export type ItemCamada = {
  chave: string;
  sigla: string;
  nome: string;
  corPreenchimento: string;
  corBorda: string;
};

const Swatch = ({ item }: { item: ItemCamada }) => (
  <Box
    flexShrink={0}
    h="3"
    w="3"
    borderRadius="sm"
    bgColor={item.corPreenchimento}
    border="1px solid"
    borderColor={item.corBorda}
  />
);

/**
 * Um grupo da lista, com a marcação do grupo inteiro no cabeçalho. O estado
 * intermediário importa: com parte das camadas desligada, a caixa do grupo
 * mostra traço em vez de fingir que tudo está ligado.
 */
export const GrupoCamadas = ({
  titulo,
  itens
}: {
  titulo: string;
  itens: ItemCamada[];
}) => {
  const {
    estaVisivel,
    alternarCamada,
    definirVisibilidade,
    siglaSelecionada,
    selecionarSigla
  } = useCamadas();
  const hoverBg = useColorModeValue("gray.100", "gray.800");

  if (!itens.length) return null;

  const chaves = itens.map((item) => item.chave);
  const visiveis = itens.filter((item) => estaVisivel(item.chave)).length;
  const todasVisiveis = visiveis === itens.length;

  return (
    <Box mt="4">
      <Checkbox
        colorScheme="main"
        isChecked={todasVisiveis}
        isIndeterminate={visiveis > 0 && !todasVisiveis}
        onChange={(e) => definirVisibilidade(chaves, e.target.checked)}
      >
        <Text fontSize="sm" fontWeight="bold">
          {`${titulo} (${itens.length})`}
        </Text>
      </Checkbox>

      <Box mt="1">
        {itens.map((item) => (
          <Flex
            key={item.chave}
            alignItems="center"
            gap="2"
            py="1"
            pl="6"
            borderRadius="sm"
            bgColor={siglaSelecionada === item.sigla ? hoverBg : "transparent"}
            _hover={{ bgColor: hoverBg }}
          >
            <Checkbox
              size="sm"
              colorScheme="main"
              isChecked={estaVisivel(item.chave)}
              onChange={() => alternarCamada(item.chave)}
              aria-label={`Exibir ${item.sigla}`}
            />
            <Swatch item={item} />
            <Box
              minW={0}
              flex="1"
              cursor="pointer"
              title={item.nome}
              // Clicar no nome realça a camada no mapa; a caixa cuida da
              // visibilidade. São duas perguntas diferentes sobre a mesma linha.
              onClick={() =>
                selecionarSigla(
                  siglaSelecionada === item.sigla ? null : item.sigla
                )
              }
            >
              <Text fontSize="xs" fontWeight="medium" noOfLines={1}>
                {item.sigla}
              </Text>
              {item.nome && (
                <TextGray fontSize="0.65rem" noOfLines={1}>
                  {item.nome}
                </TextGray>
              )}
            </Box>
          </Flex>
        ))}
      </Box>
    </Box>
  );
};
